import VectorLayer from "ol/layer/Vector";
import VectorSource from "ol/source/Vector";

import createStyles from "./createStyles";
import { sortFeaturesByZIndexAndGeom } from "./sortFeaturesByZIndexAndGeom";

const cloneLayer = (editLayer, map) => {
  const saveLayer = new VectorLayer({
    properties: {
      name: "saveLayer",
      zIndex: editLayer.getZIndex(),
    },
    source: new VectorSource({
      // [MAPSETW-446] To make sure we don't use the rbush tree.
      useSpatialIndex: false,
    }),
  });
  const clonedFeatureArray = [...editLayer.getSource().getFeatures()]
    .sort(sortFeaturesByZIndexAndGeom)
    .map((feature, index) => {
      const featureClone = feature.clone();

      // We reinitialize the zIndex each time we saved the KML
      featureClone.set("zIndex", index);

      const styleFunction = featureClone.getStyleFunction();
      if (styleFunction) {
        let styles = featureClone.getStyleFunction()(
          feature,
          map.getView().getResolution(),
        );
        styles = Array.isArray(styles) ? styles : [styles];
        featureClone.setStyle((feat, res) => {
          return createStyles(feat, res, styles, map, true);
        });
      }
      return featureClone;
    });

  saveLayer.getSource().addFeatures(clonedFeatureArray);
  return saveLayer;
};

export default cloneLayer;
